<template>
  <div class="newfeatures-thanks">
    <div class="personal-presentation-result">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2">
            <header>
              <h1 v-html="trlMessage('demo-request-thanks.title')" />
              <p
                v-if="phone"
                v-html="trlMessage('demo-request-thanks.text-with-phone', { phone: phone })"
              />
              <p v-else v-html="trlMessage('demo-request-thanks.text')" />
            </header>
            <picture>
              <source
                :srcset="`${require('@static/landing-2018/img/demo-request-success@2x.webp')} 2x,  ${require('@static/landing-2018/img/demo-request-success.webp')} 1x`"
                type="image/webp"
              />
              <source
                :srcset="`${require('@static/landing-2018/img/demo-request-success@2x.jpg')} 2x,  ${require('@static/landing-2018/img/demo-request-success.jpg')} 1x`"
                type="image/jpeg"
              />
              <img
                :src="require('@static/landing-2018/img/demo-request-success.jpg')"
                role="presentation"
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trlMessage } from '@/services/i18n';

export default {
  name: 'PresentationThanks',
  data() {
    const phone = new URL(window.location).searchParams.get('phone') || '';
    return {
      phone
    };
  },
  methods: {
    trlMessage
  }
};
</script>

<i18n lang="json">{}</i18n>
